import { render, staticRenderFns } from "./parallelClass.vue?vue&type=template&id=5dde5142&scoped=true&"
import script from "./parallelClass.vue?vue&type=script&lang=js&"
export * from "./parallelClass.vue?vue&type=script&lang=js&"
import style0 from "./parallelClass.vue?vue&type=style&index=0&id=5dde5142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dde5142",
  null
  
)

export default component.exports